<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <!-- Card stats -->
            <div class="row">
                
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Número de dietas"
                                type="gradient-orange"
                                :sub-title="count_dietas"
                                icon="ni ni-chart-pie-35"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-success mr-2"></span>
                            <span class="text-nowrap"></span>
                        </template>
                    </stats-card>
                </div>
                <div class="col-xl-3 col-lg-6">
                    <stats-card title="Dieta actual"
                                type="gradient-green"
                                :sub-title="dieta_name"
                                icon="ni ni-chart-bar-32"
                                class="mb-4 mb-xl-0">

                        <template slot="footer">
                            <span class="text-danger mr-2"></span>
                            <span class="text-nowrap"></span>
                        </template>
                    </stats-card>

                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <dietas-table title="Listado de dietas"></dietas-table>
                </div>
            </div>
            
        </div>

    </div>
</template>
<script>
  import { db } from '../../firebaseDb';
  import { auth } from '../../firebaseDb';
  import DietasTable from '../Tables/DietasTable'
  export default {
    name: 'list_dietas',
    components: {
      DietasTable
    },
    data(){
        return{
            user: auth.currentUser,
            count_dietas: "0",
            dieta_name: ""
        }
    },
    created: function(){
        db.collection('users').doc(this.user.uid).collection('dietas').get()
            .then(snapshot => this.count_dietas = snapshot.size.toString());
        var beginningDate = Date.now();
        var beginningDateObject = new Date(beginningDate);
        db.collection('users').doc(this.user.uid).collection('dietas').where("fecha_fin", ">", beginningDateObject).orderBy("fecha_fin", "asc").limit(1).get()
            .then(snapshot => {
                snapshot.forEach(doc => {
                    let item = doc.data()
                    this.dieta_name = item.dieta_name
                })
            })
    }
  };
</script>
<style></style>
